"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "IsWithinNativeNavigator", {
    enumerable: true,
    get: function() {
        return IsWithinNativeNavigator;
    }
});
function _react() {
    const data = require("react");
    _react = function() {
        return data;
    };
    return data;
}
const IsWithinNativeNavigator = (0, _react().createContext)(false);

//# sourceMappingURL=IsWithinNativeNavigator.js.map
